var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _ellipse, _path10, _rect, _ellipse2, _path11, _path12, _ellipse3, _ellipse4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGiftBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 141,
    viewBox: "0 0 166 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.143 58.4291C167.598 115.399 121.184 141.001 84.5898 141.001C47.9955 141.001 0.428589 110.23 0.428589 77.4565C0.428589 44.6835 9.16362 24.2754 45.9747 11.6379C82.7857 -0.999497 158.687 1.45873 163.143 58.4291Z",
    fill: "#F7F7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 57.6253L82.9999 74.7337V42.0723L118.5 57.6253Z",
    fill: "#7B79DF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.5 99.6183V57.625L82.9999 74.7334V116.727L118.5 99.6183Z",
    fill: "#B1B0F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4997 99.6183V57.625L82.9999 74.7334V116.727L47.4997 99.6183Z",
    fill: "#8E8CEE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4997 57.6253L82.9999 74.7337V42.0723L47.4997 57.6253Z",
    fill: "#B1B0F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6252 73.1781L47.5003 57.625L83.0004 74.7334L74.1254 91.8417L38.6252 73.1781Z",
    fill: "#7B79DF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M127.376 73.1781L118.501 57.625L83.0011 74.7334L91.8761 91.8417L127.376 73.1781Z",
    fill: "#E6E5FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.855 23.6427C126.223 24.5265 125.806 25.5417 124.922 25.9103C119.448 28.1935 114.549 33.3219 110.702 39.8508C106.871 46.3523 104.196 54.0569 103.069 61.1999C102.919 62.1457 102.032 62.7915 101.086 62.6423C100.14 62.493 99.4943 61.6053 99.6435 60.6594C100.836 53.1026 103.654 44.9817 107.714 38.0905C111.758 31.2268 117.149 25.3954 123.587 22.71C124.471 22.3414 125.486 22.759 125.855 23.6427Z",
    fill: "#B1B0F5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.8028 12.4159C79.4464 13.1249 79.3935 14.2214 78.6845 14.865C77.6491 15.8051 77.4498 17.0055 77.9645 18.584C78.5031 20.2353 79.7752 22.0237 81.2442 23.4911C83.3948 25.6392 84.3494 28.0369 83.8833 30.7955C83.4505 33.3572 81.8225 35.9857 79.5322 38.8174C77.5562 41.2605 77.1567 43.4993 77.5697 45.3928C77.9964 47.3492 79.352 49.2095 81.3805 50.6821C82.1554 51.2446 82.3276 52.3288 81.7651 53.1037C81.2026 53.8786 80.1184 54.0507 79.3435 53.4882C76.8274 51.6618 74.8366 49.1341 74.1818 46.1318C73.5133 43.0665 74.2972 39.7758 76.8361 36.6368C79.0607 33.8863 80.1889 31.8469 80.4642 30.2178C80.7062 28.7858 80.3208 27.4699 78.7937 25.9444C77.1092 24.2619 75.4377 22.0197 74.6679 19.6591C73.8743 17.2257 74.0018 14.4328 76.3537 12.2976C77.0627 11.654 78.1592 11.707 78.8028 12.4159Z",
    fill: "#8E8CEE"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 132.974,
    cy: 20.6534,
    rx: 3.05962,
    ry: 3.05962,
    fill: "#8E8CEE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M113.14 2.7303C113.162 2.564 113.367 2.49691 113.483 2.61793L115.949 5.18833C115.996 5.23691 116.064 5.25877 116.13 5.2465L119.633 4.5974C119.798 4.56683 119.925 4.74065 119.846 4.8885L118.163 8.02862C118.131 8.08796 118.132 8.15933 118.164 8.2185L119.864 11.3492C119.944 11.4967 119.818 11.6712 119.652 11.6415L116.146 11.0118C116.08 10.9999 116.012 11.0222 115.966 11.071L113.513 13.655C113.398 13.7767 113.193 13.7107 113.17 13.5446L112.686 10.0153C112.676 9.94856 112.634 9.89095 112.574 9.86196L109.358 8.32822C109.207 8.256 109.206 8.04072 109.357 7.96767L112.564 6.41614C112.625 6.38682 112.666 6.32897 112.675 6.26222L113.14 2.7303Z",
    fill: "#8E8CEE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 97.2777,
    y: 24.8242,
    width: 8.15899,
    height: 8.15899,
    rx: 1,
    transform: "rotate(-22.7167 97.2777 24.8242)",
    fill: "#8E8CEE"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 37.1045,
    cy: 30.8526,
    rx: 3.05962,
    ry: 3.05962,
    fill: "#8E8CEE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1049 33.7484C43.7555 34.64 44.1951 35.6459 45.0866 35.9953C48.0851 37.1703 51.5813 39.8938 54.8762 43.5581C58.1478 47.1964 61.0971 51.625 63.0565 56.0337C63.4454 56.9087 64.47 57.3027 65.345 56.9139C66.2201 56.525 66.6141 55.5004 66.2252 54.6253C64.1051 49.8551 60.9473 45.1237 57.4547 41.2395C53.9854 37.3814 50.0605 34.2201 46.3518 32.7667C45.4602 32.4174 44.4543 32.8569 44.1049 33.7484Z",
    fill: "#8E8CEE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7731 9.67685C51.8942 9.56084 52.0957 9.6365 52.1106 9.80357L52.4263 13.352C52.4323 13.419 52.4716 13.4786 52.5309 13.5104L55.6694 15.1959C55.8172 15.2752 55.8075 15.4903 55.6532 15.556L52.376 16.9528C52.3141 16.9792 52.2696 17.035 52.2576 17.1012L51.6245 20.6069C51.5947 20.772 51.3872 20.8293 51.277 20.7028L48.9359 18.0177C48.8916 17.9669 48.8248 17.9418 48.7581 17.9509L45.2284 18.4322C45.0622 18.4548 44.9436 18.2752 45.0298 18.1313L46.8601 15.075C46.8946 15.0172 46.8979 14.9459 46.8686 14.8853L45.3202 11.677C45.2472 11.526 45.3815 11.3577 45.545 11.3951L49.0173 12.1914C49.0829 12.2065 49.1517 12.1875 49.2003 12.1409L51.7731 9.67685Z",
    fill: "#8E8CEE"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 84.2253,
    cy: 3.55544,
    rx: 3.05962,
    ry: 3.05962,
    transform: "rotate(-12.6516 84.2253 3.55544)",
    fill: "#8E8CEE"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 65.6646,
    cy: 30.8526,
    rx: 3.05962,
    ry: 3.05962,
    fill: "#8E8CEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftBox);
export default __webpack_public_path__ + "static/media/giftBox.cee084e7684df439d15a2f2138c858b2.svg";
export { ForwardRef as ReactComponent };